import NavCollapse from './NavCollapse';

export default NavCollapse;
